<template>
  <div class='col-6'>
    <b-card v-if='!projectBudgetSummaryDataLoaded'>
      <LoadingSpinner size = '1x'/>
    </b-card>
    <div v-else>
      <b-card v-if='project && project != null && project.approvalStatus === "Approved"'
        class="col-12">
        <div class="row summary-line">
          <div class="col-6 details-label summary-line-label">Total Project Cost</div>
          <div class="col-6 text-right">
            {{ projectExpenditureTotalProjectCost | toCurrency }}
          </div>
        </div>
        <hr/>
        <div class="row">
          <div class="col-6 details-label">Cost Share</div>
          <div class="col-6 text-right">
            {{ projectExpenditureCostShare | toCurrency }}
          </div>
        </div>
        <hr/>

        <div class="row">
          <div class="col-6 details-label">
            <a v-if="projectExpenditureDistrictOrPartnerCostItems.length > 0"
              v-b-toggle.total-district-or-partner-items-collapse class="c-pointer">
              <b-icon icon='caret-right-fill' class="when-closed" />
              <b-icon icon='caret-down-fill' class="when-opened" />
              <span>District or Partner Cost</span>
            </a>
            <span v-else>
              District or Partner Cost
            </span>
          </div>
          <div class="col-6 text-right">
            {{ projectExpenditureDistrictOrPartnerCost | toCurrency }}
          </div>
        </div>
        <hr/>
        <b-collapse id="total-district-or-partner-items-collapse">
          <div v-for='item in projectExpenditureDistrictOrPartnerCostItems' :key='item.id'>
            <div class='row'>
              <div class='col-1'></div>
              <div class='col-5'>{{ item.name }}</div>
              <div class='col-6' align='right'>
                {{ item.total | toCurrency }}
              </div>
            </div>
          </div>
          <hr/>
        </b-collapse>

        <div class="row">
          <div class="col-6 details-label">
            <a v-if="projectExpenditureObligatedSpentItems.length > 0"
              v-b-toggle.total-spent-items-collapse class="c-pointer">
              <b-icon icon='caret-right-fill' class="when-closed" />
              <b-icon icon='caret-down-fill' class="when-opened" />
              <span>Spent</span>
            </a>
            <span v-else>
              Spent
            </span>
          </div>
          <div class="col-6 text-right">
            {{ projectExpenditureObligatedSpent | toCurrency }}
          </div>
        </div>
        <hr/>
        <b-collapse id="total-spent-items-collapse">
          <div v-for='item in projectExpenditureObligatedSpentItems' :key='item.id'>
            <div class='row'>
              <div class='col-1'></div>
              <div class='col-5'>{{ item.name }}</div>
              <div class='col-6' align='right'>
                {{ item.total | toCurrency }}
              </div>
            </div>
          </div>
          <hr/>
        </b-collapse>

        <div class="row">
          <div class="col-6 details-label">
            <a v-if="projectExpenditureTotalRemainingItems.length > 0"
              v-b-toggle.total-remaining-items-collapse class="c-pointer">
              <b-icon icon='caret-right-fill' class="when-closed" />
              <b-icon icon='caret-down-fill' class="when-opened" />
              <span>Remaining</span>
            </a>
            <span v-else>
              Remaining
            </span>
          </div>
          <div class="col-6 text-right">
            {{ projectExpenditureTotalRemaining | toCurrency }}
          </div>
        </div>
        <hr/>
        <b-collapse id="total-remaining-items-collapse">
          <div v-for='item in projectExpenditureTotalRemainingItems' :key='item.id'>
            <div class='row'>
              <div class='col-1'></div>
              <div class='col-5'>{{ item.name }}</div>
              <div class='col-6' align='right'>
                {{ item.total | toCurrency }}
              </div>
            </div>
          </div>
          <hr/>
        </b-collapse>

      </b-card>
      <b-card v-if='project
        && project != null
        && (project.approvalStatus === "Completed"
          || project.approvalStatus === "Cancelled")'
        class="col-12">
        <div class="row summary-line">
          <div class="col-6 details-label summary-line-label">Total Project Cost</div>
          <div class="col-6 text-right">
            {{ projectExpenditureTotalProjectCost | toCurrency }}
          </div>
        </div>
        <hr/>

        <div class="row">
          <div class="col-6 details-label">Cost Share</div>
          <div class="col-6 text-right">
            {{ projectExpenditureCostShare | toCurrency }}
          </div>
        </div>
        <hr/>

        <div class="row">
          <div class="col-6 details-label">
            <a v-if="projectExpenditureDistrictOrPartnerCostItems.length > 0"
              v-b-toggle.total-district-or-partner-items-collapse class="c-pointer">
              <b-icon icon='caret-right-fill' class="when-closed" />
              <b-icon icon='caret-down-fill' class="when-opened" />
              <span>District or Partner Cost</span>
            </a>
            <span v-else>
              District or Partner Cost
            </span>
          </div>
          <div class="col-6 text-right">
            {{ projectExpenditureDistrictOrPartnerCost | toCurrency }}
          </div>
        </div>
        <hr/>
        <b-collapse id="total-district-or-partner-items-collapse">
          <div v-for='item in projectExpenditureDistrictOrPartnerCostItems' :key='item.id'>
            <div class='row'>
              <div class='col-1'></div>
              <div class='col-5'>{{ item.name }}</div>
              <div class='col-6' align='right'>
                {{ item.total | toCurrency }}
              </div>
            </div>
          </div>
          <hr/>
        </b-collapse>

        <div class="row">
          <div class="col-6 details-label">
            <a v-if="projectExpenditureObligatedSpentItems.length > 0"
              v-b-toggle.total-spent-items-collapse class="c-pointer">
              <b-icon icon='caret-right-fill' class="when-closed" />
              <b-icon icon='caret-down-fill' class="when-opened" />
              <span>Spent</span>
            </a>
            <span v-else>
              Spent
            </span>
          </div>
          <div class="col-6 text-right">
            {{ projectExpenditureObligatedSpent | toCurrency }}
          </div>
        </div>
        <hr/>
        <b-collapse id="total-spent-items-collapse">
          <div v-for='item in projectExpenditureObligatedSpentItems' :key='item.id'>
            <div class='row'>
              <div class='col-1'></div>
              <div class='col-5'>{{ item.name }}</div>
              <div class='col-6' align='right'>
                {{ item.total | toCurrency }}
              </div>
            </div>
          </div>
          <hr/>
        </b-collapse>

        <div class="row">
          <div class="col-6 details-label">
            <a v-if="projectExpenditureCancelCompleteTotalRemainingItems.length > 0"
              v-b-toggle.total-remaining-items-collapse class="c-pointer">
              <b-icon icon='caret-right-fill' class="when-closed" />
              <b-icon icon='caret-down-fill' class="when-opened" />
              <span>Remaining</span>
            </a>
            <span v-else>
              Remaining
            </span>
          </div>
          <div class="col-6 text-right">
            {{ projectExpenditureCancelCompleteTotalRemaining | toCurrency }}
          </div>
        </div>
        <hr/>
        <b-collapse id="total-remaining-items-collapse">
          <div v-for='item in projectExpenditureCancelCompleteTotalRemainingItems' :key='item.id'>
            <div class='row'>
              <div class='col-1'></div>
              <div class='col-5'>{{ item.name }}</div>
              <div class='col-6' align='right'>
                {{ item.total | toCurrency }}
              </div>
            </div>
          </div>
          <hr/>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ProjectBudgetHelperExpenditureSummary from '@/mixins/projectBudgetHelperExpenditureSummary';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

export default {
  name: 'ExpenditureSummary',
  components: {
    LoadingSpinner,
  },
  mixins: [
    ProjectBudgetHelperExpenditureSummary,
  ],
  computed: {
    ...mapState(['config']),
    ...mapState('Project', {
      project: (state) => state.project,
      projectBudget: (state) => state.projectBudget,
      projectBudgetSummaryDataLoaded: (state) => state.projectBudgetSummaryDataLoaded,
      projectBudgetYearSnapshots: (state) => state.projectBudgetYearSnapshots,
      fundingSources: (state) => state.fundingSources,
      projectSnapshot: (state) => state.projectSnapshot,
      projectWorkorderBills: (e) => e.projectWorkorderBills,
      projectWorkorders: (state) => state.projectWorkorders,
      projectSnapshots: (state) => state.projectSnapshots,
      currentProjectSnapshots: (state) => state.currentProjectSnapshots,
      projectWorkorderLineItemFundingSources: (state) => state.projectWorkorderLineItemFundingSources,
      projectSnapshotDraft: (state) => state.projectSnapshotDraft,
    }),
  },
};
</script>
